import ReactGA from 'react-ga';
import { AuthService } from '@pingum/api-services';
import * as types from './types';

export default (state = {
  isAuthenticated: !AuthService.isTokenExpired(),
  isFetching: false,
  error: null,
}, action = {}) => {
  switch (action.type) {
    case types.LOGIN_REQUEST:
      ReactGA.event({
        category: 'User',
        action: 'Login',
      });
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case types.LOGIN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: true,
      };
    case types.LOGIN_ERROR:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: false,
        error: action.error,
      };
    case types.LOGOUT_SUCCESS:
      ReactGA.event({
        category: 'User',
        action: 'Logout',
      });
      return {
        ...state,
        isAuthenticated: false,
      };
    default:
      return state;
  }
};
